// extracted by mini-css-extract-plugin
module.exports = {"root":"TextEditor_root__HUXI9","toolbar":"TextEditor_toolbar__1xkz7","container":"TextEditor_container__xF5TB","overlay":"TextEditor_overlay__mYeFU"};